import React from "react";
import { Tab as ReactTab, TabProps as ReactTabProps } from "react-tabs";

import { SerializedStyles, styled, themeGet } from "@catchoftheday/theme";

import { ListItemProps, listItemStyleProps } from "../ListItem";

type ExtraProps = ReactTabProps &
  ListItemProps & {
    selectedCss?: SerializedStyles;
    disabledCss?: SerializedStyles;
  };

export const Tab = styled(ReactTab)<ExtraProps>`
  list-style: none;
  padding: 10px 16px;
  cursor: pointer;

  &.__catch-tab-selected__ {
    color: ${themeGet("colors.secondary")};
    border-bottom: 5px solid ${themeGet("colors.secondary")};
    ${(props) => props.selectedCss}
  }

  &.__catch-tab-disabled__ {
    cursor: not-allowed;
    color: ${themeGet("colors.grey")};
    ${(props) => props.disabledCss}
  }

  ${listItemStyleProps}
`;

Tab.defaultProps = {
  selectedClassName: "__catch-tab-selected__",
  disabledClassName: "__catch-tab-disabled__",
};

(Tab as any).tabsRole = "Tab";

export type TabProps = ListItemProps &
  ExtraProps &
  React.ComponentProps<typeof Tab>;

export default Tab;
